import { API_URL_SIGNALR } from "utils/constants";
import useSignalR from "hooks/useSignalR";
import { useAccountHelper } from "hooks/useAccountHelper";
import { useGlobalSnackbarMessage } from "hooks/useSnackbarMessage";
import { Broadcast } from "types/signalR";
import useSystemMessageReceived from "./useSystemMessageReceived";

const SignalR = () => {
  const { account } = useAccountHelper();
  const { setSnackbarValues } = useGlobalSnackbarMessage();

  // Initialize handlers for different events
  const updateSystemMessageState = useSystemMessageReceived(setSnackbarValues);

  useSignalR({
    url: API_URL_SIGNALR + "/message/negotiate",
    identifier: account?.localAccountId,
    onMessage: (msg) => {
      console.info("SignalR message received", msg);

      switch (msg.type) {
        case "Broadcast":
          console.info("Broadcast message recieved", msg);

          break;
        case "BroadcastCreated":
          console.info("BroadcastCreated message recieved", msg);
          updateSystemMessageState(msg.message as Broadcast);

          break;
        case "ProgressAnalyzed":
          console.info("ProgressAnalyzed message recieved", msg);

          break;
        case "EvaluationAnalyzed":
          console.info("EvaluationAnalyzed message recieved", msg);

          break;
        case "LearningEventUpdated":
          console.info("LearningEventUpdated message recieved", msg);

          break;

        default:
          console.error("Unknown signalR message type:", msg);
      }
    },
  });

  // This component does not render anything
  // It is used for side effects (like setting up SignalR and handling global messages)
  return null;
};

export default SignalR;
